import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import Coupon from '../Coupon';

import styles from './index.module.css';

interface TabProperty {
	label: string; // 此 tab 的文字
	index: number; // 此 tab 的 unique index
	isActive: boolean;
	handleClick: (newIndex: number) => void;
	className?: string;
}

export const Tab: React.FC<TabProperty> = ({ label, index, isActive, handleClick, className }) => (
	<button
		type="button"
		className={classnames(styles.tab, className)}
		onClick={() => handleClick(index)}
	>
		<p className={classnames({ [styles.active]: isActive })}>{label}</p>
		<div
			className={classnames(styles.activeLine, {
				[styles.hide]: !isActive,
				[styles.active]: isActive,
			})}
		/>
	</button>
);

export type TabsData = { label: string; index: number; id?: number }[];
interface TabsProperty {
	data: TabsData;
	activeIndex: number;
	handleClick: (newIndex: number) => void;
	className?: string;
	top?: number;
	autoFoucs?: boolean;
}

export const Tabs: React.FC<TabsProperty> = ({
	data,
	activeIndex,
	handleClick,
	className,
	top,
	autoFoucs = false,
}) => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (autoFoucs && ref && ref.current && ref.current.childNodes.length) {
			const tabList = ref.current.childNodes;
			const currentTab = tabList[activeIndex] as HTMLButtonElement;
			if (!currentTab) return;
			const tabRect = currentTab.getBoundingClientRect();

			if (tabRect.left < 0 || tabRect.right > window.innerWidth) {
				const position = currentTab.offsetLeft - 16;
				setTimeout(() => {
					ref.current!.scroll({
						left: position,
					});
				}, 300);
			}
		}
	}, [activeIndex, data]);

	return (
		<div className={classnames(styles.tabs, className)} style={{ top }}>
			<div className={styles.tabContainer} ref={ref}>
				{data.map(item => (
					<Tab
						label={item.label}
						index={item.index}
						isActive={activeIndex === item.index}
						className={styles.tab}
						handleClick={handleClick}
						key={item.index}
					/>
				))}
			</div>
		</div>
	);
};

// use example
const MockSwitchTabsData = [
	{ label: '涼感棉系列', index: 0 },
	{ label: '抑菌棉系列', index: 1 },
	{ label: '褲型棉系列', index: 2 },
];

const SwitchTabs: React.FC = () => {
	const [activeIndex, setActiveIndex] = useState<number>(0);
	return (
		<div>
			<Tabs
				data={MockSwitchTabsData}
				activeIndex={activeIndex}
				handleClick={(newIndex: number) => setActiveIndex(newIndex)}
			/>
			{activeIndex === 0 && (
				<Coupon
					colorStyle="purple"
					hashtag="3/8 限定 !"
					title="滿 $3500 現折"
					subtitle="涼感棉"
					briefDescription="部分組合不參與"
				/>
			)}
			{activeIndex === 1 && (
				<Coupon
					colorStyle="pink"
					hashtag="3/8 限定 !"
					title="滿 $3500 現折"
					subtitle="抑菌棉"
					briefDescription="部分組合不參與"
				/>
			)}
			{activeIndex === 2 && (
				<Coupon
					colorStyle="green"
					hashtag="3/8 限定 !"
					title="滿 $3500 現折"
					subtitle="褲型棉"
					briefDescription="部分組合不參與"
				/>
			)}
		</div>
	);
};

export default SwitchTabs;
